import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "src/app/shared/services/user.service";
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from "@angular/material/snack-bar";
import { CustomSnackMessageComponent } from "src/app/shared/components/customsnackmessage/customsnackmessage.component";

@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserManagementComponent implements OnInit {
  userData: any;
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'displayName',
    'givenName',
    'surname',
    'jobTitle',
    'mail',
    'mobilePhone',
    'userPrincipalName',
    'accountEnabled',
    'actions'
  ];

  constructor(
    private router: Router,
    public userService: UserService,
    public snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.loadUsersTable();
  }

  reDirectUrl() {
    this.router.navigate(['dashboard']);
  }

  disableUser(user: any) {
    this.userService.disableUserGraphApi(user.id).subscribe({
      next: () => {
        this.snackBar.openFromComponent(CustomSnackMessageComponent, {
          data: '' + user.displayName + ' has been disabled successfully',
          duration: 3000,
          verticalPosition: 'top',
          panelClass: ['default-snackbar'],
        });
        this.loadUsersTable();
      },
    });
  }

  enableUser(user: any) {
    this.userService.enableUserGraphApi(user.id).subscribe({
      next: () => {
        this.snackBar.openFromComponent(CustomSnackMessageComponent, {
          data: '' + user.displayName + ' has been activated successfully',
          duration: 3000,
          verticalPosition: 'top',
          panelClass: ['default-snackbar'],
        });
        this.loadUsersTable();
      },
    });
  }

  loadUsersTable() {
    this.userService.getAllUsersGraphApi().subscribe({
      next: (users) => {
        const orderedUserData = users.value.sort((a: any, b: any) => {
          const nameA = a.displayName || "";
          const nameB = b.displayName || "";
          return nameA.localeCompare(nameB);
        });

        this.dataSource.data = orderedUserData;
        this.userData = orderedUserData;
      },
    });
  }
}